import { render, staticRenderFns } from "./date-table.vue?vue&type=template&id=e05beb0a&"
import script from "./date-table.vue?vue&type=script&lang=js&"
export * from "./date-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports